import { HashRouter, Routes, Route, Navigate } from 'react-router-dom';
import { auth } from './lib/firebase';
import { onAuthStateChanged, User } from 'firebase/auth';
import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { TabLayout } from './components/tab-layout';
import { DirectionsTab } from './pages/directions-tab';
import { RoutesTab } from './pages/routes-tab';
import { LoginPage } from './pages/login';

const AuthContext = createContext<{ user: User | null; loading: boolean }>({ user: null, loading: true });
export const useAuth = () => useContext(AuthContext);

function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (u) => {
      setUser(u);
      setLoading(false);
    });
    return () => unsub();
  }, []);

  return <AuthContext.Provider value={{ user, loading }}>{children}</AuthContext.Provider>;
}

function PrivateRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center">Loading...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <AuthProvider>
      <HashRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<PrivateRoute><TabLayout /></PrivateRoute>}>
            <Route index element={<Navigate to="/directions" replace />} />
            <Route path="directions" element={<DirectionsTab />} />
            <Route path="routes" element={<RoutesTab />} />
          </Route>
        </Routes>
      </HashRouter>
    </AuthProvider>
  );
}
